import React from 'react';
import { Menu } from 'lucide-react';
interface HeaderProps {
  onNavigateHome: () => void;
}
export function Header({
  onNavigateHome
}: HeaderProps) {
  return <header className="sticky top-0 z-40 w-full bg-white/80 backdrop-blur-md border-b border-slate-200 shadow-sm shrink-0" data-id="element-35">
      <div className="w-full px-4 md:px-6 h-14 flex items-center justify-between" data-id="element-36">
        <button onClick={onNavigateHome} className="flex items-center gap-2.5 hover:opacity-80 transition-opacity focus:outline-none focus:ring-2 focus:ring-teal-500 rounded-lg p-1" aria-label="Go to home" data-id="element-37">
          {/* Health Department Shield Icon */}
          <div className="w-8 h-8 bg-teal-700 rounded-lg flex items-center justify-center shrink-0" data-id="element-38">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-39">
              <path d="M12 2L3 7v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5z" fill="white" opacity="0.3" data-id="element-40" />
              <path d="M12 2L3 7v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5z" stroke="white" strokeWidth="1.5" fill="none" data-id="element-41" />
              <path d="M12 8v8M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" data-id="element-42" />
            </svg>
          </div>
          <div className="flex flex-col leading-none" data-id="element-43">
            <span className="text-sm font-bold tracking-tight text-slate-900" data-id="element-44">
              Franklin County
            </span>
            <span className="text-[11px] font-medium text-slate-500 tracking-wide" data-id="element-45">
              HEALTH DEPARTMENT
            </span>
          </div>
        </button>

        <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-slate-600" data-id="element-46">
          <button onClick={onNavigateHome} className="hover:text-teal-700 transition-colors" data-id="element-47">
            Map
          </button>
          <button className="hover:text-teal-700 transition-colors" data-id="element-48">
            About Ratings
          </button>
        </nav>

        <button className="md:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors" data-id="element-49">
          <Menu className="w-5 h-5" data-id="element-50" />
        </button>
      </div>
    </header>;
}